import React from 'react'
import { array } from 'prop-types'

import Grid from '@/component/Primitive/Grid'
import InlineImage from '@/component/Composition/InlineImage'
import changeFileExtension from '@/lib/filename-extension-modifier'

const InlineImageWidget = ({ inlineImageImages }) => {
  const formattedImages = inlineImageImages
    .map((image) => {
      const imageDataArray = Object.values(image.images)[0]
      if (!imageDataArray) return
      const { alt, caption } = imageDataArray[0]
      const getImage = ({ width, ratio }) =>
        image.images?.[`inline_${ratio}_${width}`]?.[0]

      const getImageData = ({ ratio }) => {
        const ratioMap = {
          Free: 'free',
          '167:126': 'landscape',
          Landscape: 'landscape'
        }
        if (ratioMap[ratio]) {
          const primaryImage = getImage({
            width: 668,
            ratio: ratioMap[ratio]
          })
          return {
            destination: image.destination,
            opensInNewTab: image.opensInNewTab,
            src: primaryImage.url,
            width: primaryImage.width,
            height: primaryImage.height,
            ratio: primaryImage.ratio,
            srcSet: [
              {
                width: 668,
                src: changeFileExtension(
                  getImage({ width: 668, ratio: ratioMap[ratio] }).url,
                  'webp'
                )
              },
              {
                width: 900,
                src: changeFileExtension(
                  getImage({ width: 900, ratio: ratioMap[ratio] }).url,
                  'webp'
                )
              },
              {
                width: 1336,
                src: changeFileExtension(
                  getImage({ width: 1336, ratio: ratioMap[ratio] }).url,
                  'webp'
                )
              },
              {
                width: 1800,
                src: changeFileExtension(
                  getImage({ width: 1800, ratio: ratioMap[ratio] }).url,
                  'webp'
                )
              }
            ],
            sizes: ['(min-width: 960px) 668px', 'calc(100vw - 32px)']
          }
        }
        return []
      }

      const imageData = getImageData({ ratio: inlineImageImages[0].crop })
      return {
        alt: alt || '',
        caption,
        destination: imageData.destination,
        opensInNewTab: imageData.opensInNewTab,
        src: imageData.src,
        width: imageData.width,
        height: imageData.height,
        srcSet: imageData.srcSet,
        sizes: imageData.sizes,
        ratio: imageData.ratio
      }
    })
    .filter((v) => v)

  if (formattedImages.length > 1) {
    return (
      <Grid gutter="default">
        {formattedImages.map((image, i) => (
          <Grid.Item key={`InlineImage:Image:${i}`} width={{ d: 1 / 2 }}>
            <InlineImage {...image} />
          </Grid.Item>
        ))}
      </Grid>
    )
  }
  return <InlineImage {...formattedImages[0]} />
}

InlineImageWidget.propTypes = {
  inlineImageImages: array // TODO: shape
}

export default InlineImageWidget
